import React, { useEffect, useRef, useState } from "react";
import { SITE } from "@/constants/testIds";

const stats = [
  { value: 50, suffix: "+", label: "Tamamlanan Proje" },
  { value: 12, suffix: "+", label: "İzmir & Ege Bölgesi Şehri" },
  { value: 100, suffix: "%", label: "Müşteri Memnuniyeti" },
  { value: 14, suffix: "+", label: "Yıllık Sektörel Deneyim" },
];

const useCounter = (end, start = 0, duration = 1800, run = false) => {
  const [value, setValue] = useState(start);
  useEffect(() => {
    if (!run) return;
    let raf;
    const t0 = performance.now();
    const tick = (t) => {
      const p = Math.min(1, (t - t0) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setValue(Math.floor(start + (end - start) * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [end, start, duration, run]);
  return value;
};

const StatItem = ({ item, index, run }) => {
  const val = useCounter(item.value, 0, 1600 + index * 150, run);
  return (
    <div
      className="p-8 md:p-10 lg:p-12 border-l border-neutral-900 first:border-l-0"
    >
      <div
        data-testid={SITE.statValue(index)}
        className="font-mono-tech text-[#ff5a00] text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight"
      >
        {val}
        <span className="text-3xl md:text-4xl lg:text-5xl">{item.suffix}</span>
      </div>
      <div className="mt-4 font-mono-tech text-[11px] uppercase tracking-[0.28em] text-neutral-400 max-w-[220px]">
        {item.label}
      </div>
    </div>
  );
};

export const Stats = () => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!ref.current) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setVisible(true);
            obs.disconnect();
          }
        });
      },
      { threshold: 0.25 }
    );
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      className="relative py-4 border-y border-neutral-900 bg-[#050506]"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 divide-neutral-900">
          {stats.map((s, i) => (
            <StatItem key={i} item={s} index={i} run={visible} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
